(() => {
/* One script drives both builders. The gift box page is any Bundler page whose
   address contains "gift" (or ?gift=1); everything else is the tablescape. */
const GIFT = /gift/i.test(location.pathname) || new URLSearchParams(location.search).has('gift');
/* Prices follow the shopper's currency. The Bundler takes fixed amounts off for
   2 and 3 pairs (2 and 6 in whatever currency is showing) and 7.69% off from 4. */
const CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
const GBP = CURRENCY === 'GBP';
const PRICES = {
  GBP: { sym: '£', one: 26, two: 50, three: 72 },
  EUR: { sym: '€', one: 32, two: 62, three: 90 },
  USD: { sym: '$', one: 36, two: 70, three: 102 }
}[CURRENCY] || null;
const money = amount => PRICES.sym + amount;

const COPY = GIFT ? {
  title: 'Pack a Gift Box',
  add: 'Add to box',
  trayLabel: 'Your gift box',
  cta: 'Add gift box to bag'
} : {
  title: 'Set a table worth talking about',
  add: 'Add to table',
  trayLabel: 'Your table',
  cta: 'Add tablescape to bag'
};

/* ---- The progress line and its nudges: edit these ---- */
/* Labels along the line. 1, 2 and 3 pairs sit on the solid line; 4+ sits at
   the end of the fade that follows it, with a small note underneath. */
const STOPS = PRICES ? [
  { pairs: 1, lines: ['1 pair', money(PRICES.one)] },
  { pairs: 2, lines: ['2 pairs', money(PRICES.two)] },
  { pairs: 3, lines: ['3 pairs', money(PRICES.three)] },
  GBP
    ? { pairs: 4, lines: ['4+ · £24 a pair'], note: 'Free UK delivery', more: true }
    : { pairs: 4, lines: ['4+ · save 7.7%'], more: true }
] : [
  { pairs: 1, lines: ['1 pair'] },
  { pairs: 2, lines: ['2 pairs'] },
  { pairs: 3, lines: ['3 pairs'] },
  { pairs: 4, lines: ['4+ pairs'], more: true }
];
/* The line above the bar. One entry each for 0, 1, 2, 3 and 4+ pairs chosen. */
const NUDGES = GIFT
  ? (GBP ? [
      '',
      'Add a second. £50 for two.',
      'A third pair turns a present into a showstopper.',
      'One more pair and UK delivery’s on us.',
      'Free UK delivery, with their card tucked inside.'
    ] : [
      '',
      PRICES ? 'Add a second. ' + money(PRICES.two) + ' for two.' : 'Add a second pair to the box.',
      'A third pair turns a present into a showstopper.',
      'The more pairs, the less each one costs.',
      'Their card goes in with them.'
    ])
  : (GBP ? [
      '',
      'Add a second. £50 for two.',
      'A third pair and the table really starts to glow.',
      'One more pair and UK delivery’s on us.',
      'Free UK delivery. The table’s all yours.'
    ] : [
      '',
      PRICES ? 'Add a second. ' + money(PRICES.two) + ' for two.' : 'Add a second pair to your table.',
      'A third pair and the table really starts to glow.',
      'The more pairs, the less each one costs.',
      'The table’s all yours.'
    ]);
/* The short version in the basket tray at the bottom (for 1, 2, 3 and 4+ pairs). */
const TRAY_NUDGES = GBP
  ? ['', '+1 pair · £50 for two', '+1 pair · £72 for three', '+1 pair · free UK delivery', 'Free UK delivery']
  : (PRICES
    ? ['', '+1 pair · ' + money(PRICES.two) + ' for two', '+1 pair · ' + money(PRICES.three) + ' for three', '+1 pair · save 7.7%', 'Saving 7.7% a pair']
    : ['', '', '', '', '']);

/* ---- Candle order: by colour, changing with the seasons ---- */
/* Each colour's candles, best sellers with good stock first (sales and stock
   checked 2 Nov 2026). Two-colour candles sit by the first colour in their
   product title. Munro and Woodstock sit with the browns, Bramble with the
   burgundies and Wimbledon with the greens. Tile Collection: Delft is blue,
   Thyme and Checker green, Porter neutral. Low stock goes last in its colour.
   When a colour is chosen in the filter, that colour's own candles lead.
   The four blocks top, tileblue, warm and mono are only used in the autumn
   order. A candle must appear in only one block of a season's order. */
const COLOUR_BLOCKS = {
  orange: ['Marmalade', 'Jaffa', 'Berber', 'Humbug', 'Terracotta', 'Marrakech', 'Deia', 'Hoxton'],
  brown: ['Walnut', 'Munro', 'Woodstock'],
  burgundy: ['Bramble', 'Marylebone', 'Drawing Room'],
  red: ['Rhubarb', 'Beckford', 'Crab Claw'],
  pink: ['Jam Tart', 'Crumpet', 'Pink Lady', 'Radish', 'Bloom', 'Peony', 'Sweet Pea'],
  green: ['Hedgerow', 'Potting Shed', 'Babington', 'Botanist', 'Gardener', 'Wimbledon', 'Gooseberry', 'Hampstead', 'Thyme', 'Checker', 'Olives', 'Kissing Gate', 'Chilmark', 'Bergamot', 'Petersham'],
  blue: ['Highbury', 'Delft', 'Majorelle', 'Herring'],
  black: ['Twiglet', 'Edition', 'Shilling'],
  white: ['Pavlova', 'Porter', 'Oddity'],
  yellow: ['Piccalilli', 'Butter Boy', 'Sherbet', 'Sunshine', 'Carnaby'],
  top: ['Beckford', 'Berber', 'Munro', 'Bramble', 'Marylebone', 'Rhubarb', 'Walnut', 'Drawing Room', 'Crab Claw', 'Woodstock'],
  tileblue: ['Terracotta', 'Highbury', 'Delft', 'Majorelle', 'Herring'],
  warm: ['Marmalade', 'Jaffa', 'Humbug', 'Marrakech', 'Deia', 'Hoxton'],
  mono: ['Twiglet', 'Pavlova', 'Edition', 'Porter', 'Shilling', 'Oddity']
};
/* Which colours lead in each season. Autumn: 1 Sept to 30 Nov. Christmas:
   1 Dec to end of Feb. Spring: 1 Mar to 31 May. Summer: 1 Jun to 31 Aug.
   To preview another season, add ?season=christmas (or spring, summer,
   autumn) to the page address. */
const SEASONS = {
  autumn: ['top', 'green', 'tileblue', 'warm', 'mono', 'pink', 'yellow'],
  christmas: ['red', 'burgundy', 'green', 'black', 'white', 'blue', 'orange', 'brown', 'pink', 'yellow'],
  spring: ['pink', 'green', 'yellow', 'white', 'blue', 'orange', 'red', 'burgundy', 'brown', 'black'],
  summer: ['green', 'blue', 'yellow', 'pink', 'orange', 'red', 'white', 'black', 'burgundy', 'brown']
};
const SEASON = (() => {
  const asked = new URLSearchParams(location.search).get('season');
  if (asked && SEASONS[asked]) return asked;
  const month = new Date().getMonth() + 1;
  if (month === 12 || month <= 2) return 'christmas';
  if (month <= 5) return 'spring';
  if (month <= 8) return 'summer';
  return 'autumn';
})();
/* Any candle not listed above goes at the end. */
const COLOUR_ORDER = SEASONS[SEASON].flatMap(colour => COLOUR_BLOCKS[colour] || []);

/* ---- Gift box settings: edit these ---- */
const GIFT_LEDE = 'Choose their candles. We’ll box them beautifully and tuck your note inside.';
/* Christmas line under the gift prices. Leave empty ('') to hide it,
   e.g. 'Order by Thursday 17 December for UK Christmas delivery' */
const GIFT_DEADLINE = '';
/* Ready-made boxes (gift page) and occasion edits (tablescape page).
   Candle names must match the builder exactly (any case). A box whose candles
   aren't all in the bundle hides itself. */
const GIFT_BOXES = [
  { name: 'For the Host', candles: ['Humbug'] },
  { name: 'Stocking Filler', candles: ['Sherbet'] },
  { name: 'The Housewarming', candles: ['Hedgerow', 'Botanist'] },
  { name: 'The Happy Couple', candles: ['Kissing Gate', 'Peony'] },
  { name: 'New Baby', candles: ['Sweet Pea', 'Pavlova'] },
  { name: 'The Showstopper', candles: ['Jam Tart', 'Marmalade', 'Rhubarb'] },
  { name: 'Christmas Table', candles: ['Wimbledon', 'Bramble', 'Crumpet'] }
];
const TABLE_EDITS = [
  { name: 'Date Night', candles: ['Drawing Room', 'Beckford'] },
  { name: 'Sunday Roast', candles: ['Potting Shed', 'Rhubarb', 'Woodstock'] },
  { name: 'Girls’ Night', candles: ['Peony', 'Sweet Pea', 'Kissing Gate', 'Jam Tart'] },
  { name: 'Halloween', candles: ['Humbug', 'Walnut', 'Marmalade', 'Oddity'] },
  { name: 'Thanksgiving', candles: ['Terracotta', 'Marmalade', 'Walnut', 'Hedgerow'] },
  { name: 'Christmas', candles: ['Wimbledon', 'Bramble', 'Crumpet', 'Drawing Room'] }
];
const READY = GIFT ? {
  list: GIFT_BOXES, head: 'Or start with one of ours', note: 'Swap any candle once it’s in your box.', where: 'your gift box', label: 'Ready-made gift boxes'
} : {
  list: TABLE_EDITS, head: 'Start with an occasion', note: 'Swap any candle once it’s on your table.', where: 'your table', label: 'Tables for every occasion'
};
/* Hidden until the styled photos are shot. Set to true to show the boxes. */
const SHOW_READY = false;
const GIFT_PRICES = { 1: '£26', 2: '£50', 3: '£72' };
/* --------------------------------------- */

/* ---- Filter: collections and colours ---- */
const COLLECTIONS = {
  pinstripe: ['bramble', 'butter boy', 'pink lady', 'rhubarb', 'babington', 'beckford', 'drawing room', 'humbug', 'crumpet', 'herring', 'wimbledon', 'gooseberry', 'bergamot'],
  scallop: ['marylebone', 'botanist', 'twiglet', 'gardener', 'kissing gate', 'marmalade'],
  artisan: ['terracotta', 'edition', 'majorelle', 'oddity', 'munro', 'berber'],
  classic: ['potting shed', 'highbury', 'woodstock', 'hoxton', 'petersham', 'edition', 'chilmark', 'crab claw', 'deia', 'hampstead'],
  marbled: ['jam tart', 'hedgerow', 'shilling', 'walnut', 'jaffa', 'piccalilli', 'pavlova', 'sherbet'],
  ombre: ['radish', 'olives', 'carnaby', 'bloom', 'peony', 'marrakech', 'sunshine', 'sweet pea'],
  tile: ['delft', 'porter', 'thyme', 'checker']
};

/* Colours come from each candle's product title (e.g. "Marylebone Burgundy & Cream").
   A candle can sit in more than one colour. Creams, oyster, sand and off-white
   count as white; charcoal counts as black. Wimbledon is filed as white and
   green rather than pink, as its pink doesn't read on the candle. */
const COLOURS = {
  pink: ['deia', 'marmalade', 'radish', 'sweet pea', 'woodstock', 'peony', 'bloom', 'rhubarb', 'crumpet', 'crab claw', 'pink lady', 'jam tart', 'kissing gate'],
  red: ['deia', 'radish', 'rhubarb', 'crab claw', 'pink lady', 'beckford', 'berber', 'jam tart'],
  burgundy: ['marylebone', 'drawing room', 'bramble'],
  orange: ['humbug', 'deia', 'marmalade', 'marrakech', 'hoxton', 'terracotta', 'berber', 'munro', 'jaffa'],
  yellow: ['bergamot', 'carnaby', 'sunshine', 'butter boy', 'sherbet', 'piccalilli'],
  green: ['babington', 'bergamot', 'highbury', 'olives', 'petersham', 'potting shed', 'sweet pea', 'woodstock', 'chilmark', 'bloom', 'crumpet', 'botanist', 'gooseberry', 'wimbledon', 'herring', 'bramble', 'gardener', 'munro', 'hedgerow', 'kissing gate', 'hampstead', 'thyme', 'checker'],
  blue: ['highbury', 'hoxton', 'herring', 'majorelle', 'delft'],
  brown: ['walnut', 'munro', 'woodstock'],
  black: ['edition', 'twiglet', 'gooseberry', 'shilling'],
  white: ['humbug', 'babington', 'twiglet', 'chilmark', 'peony', 'botanist', 'bramble', 'beckford', 'walnut', 'hedgerow', 'pavlova', 'sherbet', 'jaffa', 'marylebone', 'oddity', 'wimbledon', 'delft', 'porter']
};

const COLLECTION_LABELS = [
  ['all', 'All'], ['pinstripe', 'Pinstripe'], ['scallop', 'Scallop'], ['artisan', 'Artisan'],
  ['classic', 'Classic'], ['marbled', 'Marbled'], ['ombre', 'Ombré'], ['tile', 'Tile']
];

const COLOUR_LABELS = [
  ['all', 'All'], ['pink', 'Pink'], ['red', 'Red'], ['burgundy', 'Burgundy'], ['orange', 'Orange'],
  ['yellow', 'Yellow'], ['green', 'Green'], ['blue', 'Blue'], ['brown', 'Brown'], ['black', 'Black'], ['white', 'White']
];

/* The small dot shown beside each colour. */
const SWATCHES = {
  pink: '#E2A3AA', red: '#B8322F', burgundy: '#6B1F2A', orange: '#CA4E22', yellow: '#D5CF58',
  green: '#5B6B3A', blue: '#3E5A86', brown: '#6E4B2F', black: '#212622', white: '#FAFAFA'
};
/* --------------------------------------- */

let activeCollection = 'all';
let activeColour = 'all';
let refreshQueued = false;
const selectionOrder = new Map();
let nextSelectionOrder = 0;

const normalise = value => (value || '')
  .toLowerCase()
  .replace(/&amp;/g, '&')
  .replace(/[^a-z0-9\s-]/g, '')
  .replace(/\s+/g, ' ')
  .trim();

const escapeHtml = value => String(value).replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));

function titleFor(card) {
  return normalise(card.querySelector('.bndlr-product-title')?.textContent);
}

function pairsChosen(root) {
  return [...root.querySelectorAll('.bndlr-mnm-selected-products > .bndlr-product')]
    .reduce((total, product) => total + quantityFor(product), 0);
}

/* ---------- Shared builder styles (both pages) ---------- */

function injectStyles() {
  if (document.getElementById('pyg-gift-box-css')) return;
  const style = document.createElement('style');
  style.id = 'pyg-gift-box-css';
  style.textContent = `
html.pyg-bundle-page .pyg-bundle-intro{background:#F0EDE5!important;padding:52px 32px 0}
html.pyg-bundle-page body .pyg-bundle-intro .bndlr-bundle-title{font-size:clamp(20px,1.7vw,26px)!important;letter-spacing:.14em!important;line-height:1.2!important;color:#381B21!important}
html.pyg-bundle-page .pyg-bundle-intro .pyg-catalogue-tools{border-bottom:0;margin-top:20px}
.pyg-tier-bar{--pyg-solid:75%;width:100%;max-width:720px;margin:34px auto 0;display:flex;flex-direction:column;gap:14px;text-align:left}
.pyg-tier-nudge{margin:0;min-height:1.4em;font-family:'Pygmalion Acumin',acumin-pro,Arial,sans-serif;font-size:12px;line-height:1.4;letter-spacing:.14em;text-transform:uppercase;color:#381B21}
.pyg-tier-track{position:relative;height:8px}
.pyg-tier-line,.pyg-tier-fill{position:absolute;left:0;top:0;bottom:0}
.pyg-tier-line{width:var(--pyg-solid);background:#D9D3C8}
.pyg-tier-fill{width:0;background:#381B21;transition:width .45s ease}
.pyg-tier-tail{position:absolute;left:var(--pyg-solid);right:0;top:0;bottom:0;background:#D9D3C8;-webkit-mask-image:linear-gradient(90deg,#000 5%,transparent);mask-image:linear-gradient(90deg,#000 5%,transparent)}
.pyg-tier-tail-fill{display:block;width:0;height:100%;background:#381B21;transition:width .45s ease}
.pyg-tier-bar[data-step="1"] .pyg-tier-fill{width:calc(var(--pyg-solid) / 3)}
.pyg-tier-bar[data-step="2"] .pyg-tier-fill{width:calc(var(--pyg-solid) * 2 / 3)}
.pyg-tier-bar:is([data-step="3"],[data-step="4"],[data-step="5"],[data-step="6"]) .pyg-tier-fill{width:var(--pyg-solid)}
.pyg-tier-bar[data-step="4"] .pyg-tier-tail-fill{width:34%}
.pyg-tier-bar[data-step="5"] .pyg-tier-tail-fill{width:67%}
.pyg-tier-bar[data-step="6"] .pyg-tier-tail-fill{width:100%}
.pyg-tier-stops{position:relative;height:40px;list-style:none;margin:0;padding:0}
.pyg-tier-stops li{position:absolute;top:0;right:calc(100% - var(--at));margin:0;text-align:right;white-space:nowrap;font-family:'Pygmalion Acumin',acumin-pro,Arial,sans-serif;font-size:12px;line-height:1.35;letter-spacing:.12em;text-transform:uppercase;color:#381B21;opacity:.55;transition:opacity .25s}
.pyg-tier-stops li.is-reached{opacity:1}
.pyg-tier-stops li span+span::before{content:' · '}
.pyg-tier-stops li.is-more span{display:block}
.pyg-tier-stops li.is-more span+span::before{content:none}
.pyg-tier-stops li .pyg-tier-note{margin-top:3px;font-size:10px;font-style:italic;letter-spacing:.04em;text-transform:none}
.pyg-tier-stops li .pyg-tier-note::before{content:none!important}
#bndlr-mnm-status-box .pyg-tray-nudge{font-family:'Pygmalion Kindersley',kindersley,Georgia,serif;font-size:16px;line-height:1.2;color:#D9D3C4;opacity:.9;white-space:nowrap}
#bndlr-mnm-status-box .pyg-tray-nudge[hidden]{display:none}
.pyg-bundle-page .pyg-filter-sheet{position:absolute;top:44px;right:0;z-index:40;box-sizing:border-box;width:min(340px,calc(100vw - 28px));padding:22px 26px 14px;background:#F0EDE5;border:1px solid rgba(56,27,33,.2);color:#381B21;text-align:left}
.pyg-bundle-page .pyg-filter-heading{margin:0 0 6px;font-family:'Pygmalion Acumin',acumin-pro,Arial,sans-serif;font-size:9.5px;line-height:1.2;letter-spacing:.2em;text-transform:uppercase;color:#381B21;opacity:.55}
.pyg-bundle-page .pyg-filter-list{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:0 18px;margin:0 0 18px}
.pyg-bundle-page .pyg-filter-option{appearance:none;display:inline-flex;align-items:center;gap:9px;min-height:32px;margin:0;padding:0!important;border:0!important;border-radius:0;background:none!important;box-shadow:none!important;color:#381B21!important;cursor:pointer;font-family:'Pygmalion Acumin',acumin-pro,Arial,sans-serif!important;font-size:11.5px!important;font-weight:400;line-height:1.2;letter-spacing:.16em!important;text-transform:uppercase!important;text-align:left;white-space:nowrap}
.pyg-bundle-page .pyg-filter-option .pyg-filter-text{padding-bottom:2px;border-bottom:1px solid transparent;transition:border-color .2s ease}
.pyg-bundle-page .pyg-filter-option:hover .pyg-filter-text,.pyg-bundle-page .pyg-filter-option[aria-checked="true"] .pyg-filter-text{border-bottom-color:#381B21}
.pyg-bundle-page .pyg-filter-option:focus-visible{outline:1px solid #381B21;outline-offset:3px}
.pyg-bundle-page .pyg-filter-dot{width:8px;height:8px;flex:none;border-radius:50%;box-shadow:inset 0 0 0 1px rgba(56,27,33,.25)}
.pyg-bundle-page .pyg-filter-foot{display:flex;justify-content:space-between;align-items:center;gap:12px;padding-top:12px;border-top:1px solid rgba(56,27,33,.16);font-family:'Pygmalion Acumin',acumin-pro,Arial,sans-serif;font-size:9.5px;letter-spacing:.2em;text-transform:uppercase;color:#381B21}
.pyg-bundle-page .pyg-filter-count{opacity:.6}
.pyg-bundle-page .pyg-filter-clear{appearance:none;margin:0;padding:0!important;min-height:28px;border:0!important;background:none!important;color:#381B21!important;cursor:pointer;font-family:inherit!important;font-size:inherit!important;letter-spacing:inherit!important;text-transform:inherit!important;text-decoration:underline;text-underline-offset:3px}
.pyg-bundle-page .pyg-filter-clear[hidden]{display:none}
.pyg-bundle-page .pyg-filter-mark{display:inline-block;width:5px;height:5px;margin-left:-4px;border-radius:50%;background:currentColor}
.pyg-bundle-page .pyg-filter-mark[hidden]{display:none}
@media (pointer:coarse){.pyg-bundle-page .pyg-filter-option{min-height:40px}}
@media (max-width:760px){
html.pyg-bundle-page .pyg-bundle-intro{padding:36px 18px 0}
html.pyg-bundle-page body .pyg-bundle-intro .bndlr-bundle-title{font-size:19px!important;letter-spacing:.1em!important}
.pyg-tier-bar{--pyg-solid:66%;margin-top:24px;gap:12px}
.pyg-tier-nudge{font-size:10.5px;letter-spacing:.1em}
.pyg-tier-stops{height:46px}
.pyg-tier-stops li{right:calc(100% - var(--at-m));font-size:9.5px;letter-spacing:.08em}
.pyg-tier-stops li span{display:block}
.pyg-tier-stops li span+span::before{content:none}
.pyg-tier-stops li .pyg-tier-note{font-size:9px}
#bndlr-mnm-status-box .pyg-tray-nudge{font-size:13px}
}
@media (prefers-reduced-motion:reduce){.pyg-tier-fill,.pyg-tier-tail-fill,.pyg-tier-stops li,.pyg-filter-text{transition:none}}
.pyg-gift-lede{max-width:520px;margin:.9rem auto 0;text-align:center;font-family:var(--pyg-kindersley,Georgia,serif);font-size:15px;line-height:1.5;color:#381B21}
.pyg-gift-deadline{margin:1rem auto 0;opacity:.75;text-align:center;font-family:var(--pyg-acumin,Arial,sans-serif);font-size:10.5px;letter-spacing:.12em;text-transform:uppercase;color:#381B21}
.pyg-gift-deadline::before{content:'';display:inline-block;width:6px;height:6px;border-radius:50%;background:#381B21;margin-right:.8rem;vertical-align:middle}
.pyg-gift-boxes{margin:2.4rem auto 0;max-width:980px}
.pyg-gift-boxes__head{margin:0 0 1.2rem;text-align:center;font-family:var(--pyg-kindersley,Georgia,serif);font-size:18px;color:#381B21}
.pyg-gift-boxes__row{display:flex;flex-wrap:wrap;justify-content:center;gap:10px}
.pyg-gift-boxes__item{flex:0 1 220px;display:flex;flex-direction:column;align-items:center;gap:6px;padding:16px 10px;border:1px solid rgba(56,27,33,.25);background:transparent;color:#381B21;cursor:pointer;text-align:center;transition:background .15s,color .15s}
.pyg-gift-boxes__item:hover,.pyg-gift-boxes__item:focus-visible{background:#381B21;color:#FAFAFA}
.pyg-gift-boxes__item[aria-busy="true"]{opacity:.5;pointer-events:none}
.pyg-gift-boxes__name{font-family:'Montage-Serif-Font',Georgia,serif;font-size:14px;letter-spacing:.06em;text-transform:uppercase}
.pyg-gift-boxes__list{font-family:var(--pyg-kindersley,Georgia,serif);font-size:13px;line-height:1.4;opacity:.85}
.pyg-gift-boxes__price{font-family:var(--pyg-acumin,Arial,sans-serif);font-size:11px;letter-spacing:.12em;text-transform:uppercase}
.pyg-gift-boxes__note{margin:1rem 0 0;text-align:center;font-family:var(--pyg-kindersley,Georgia,serif);font-size:13px;font-style:italic;color:rgba(56,27,33,.7)}
@media (max-width:749px){.pyg-gift-boxes__item{flex-basis:calc(50% - 5px)}}
.pyg-tray-card{width:auto;margin:0;white-space:nowrap}
html.pyg-gift-page .pyg-table-label{white-space:nowrap!important}
.pyg-tray-card__toggle{border:0;background:none;padding:0;cursor:pointer;color:inherit;font-family:var(--pyg-acumin,Arial,sans-serif);font-size:11px;letter-spacing:.12em;text-transform:uppercase;text-decoration:underline;text-underline-offset:3px}
.pyg-tray-card__body{margin-top:.6rem}
.pyg-tray-card__body textarea{width:100%;min-height:64px;border:1px solid rgba(56,27,33,.25);background:#FAFAFA;padding:10px;font-family:var(--pyg-kindersley,Georgia,serif);font-size:15px;line-height:1.45;color:#381B21;resize:vertical;box-sizing:border-box}
.pyg-tray-card__body textarea::placeholder{color:rgba(56,27,33,.45);font-style:italic}
.pyg-tray-card__meta{display:flex;justify-content:space-between;margin:4px 0 0;font-family:var(--pyg-acumin,Arial,sans-serif);font-size:10.5px;letter-spacing:.08em;opacity:.65}`;
  document.head.appendChild(style);
}

async function saveGiftCard(message) {
  const attributes = { 'Gift card': 'Yes' };
  if (typeof message === 'string') attributes['Gift card message'] = message.trim();
  try {
    await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes })
    });
  } catch (e) { /* the order still goes through; the card is complimentary anyway */ }
}

function buildGiftBoxes(root, grid) {
  if (!SHOW_READY || root.querySelector('.pyg-gift-boxes')) return;
  const cards = [...grid.querySelectorAll(':scope > .bndlr-product')];
  if (!cards.length) return;
  const byTitle = new Map(cards.map(card => [titleFor(card), card]));
  const boxes = READY.list.filter(box => box.candles.every(name => byTitle.has(normalise(name))));
  if (!boxes.length) return;
  const section = document.createElement('section');
  section.className = 'pyg-gift-boxes';
  section.setAttribute('aria-label', READY.label);
  section.innerHTML = `<p class="pyg-gift-boxes__head">${READY.head}</p><div class="pyg-gift-boxes__row"></div><p class="pyg-gift-boxes__note">${READY.note}</p>`;
  const row = section.querySelector('.pyg-gift-boxes__row');
  boxes.forEach(box => {
    const count = box.candles.length;
    const price = GIFT_PRICES[count] || '£' + (24 * count);
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'pyg-gift-boxes__item';
    button.innerHTML = `<span class="pyg-gift-boxes__name">${escapeHtml(box.name)}</span><span class="pyg-gift-boxes__list">${box.candles.map(escapeHtml).join(', ')}</span><span class="pyg-gift-boxes__price">${count} ${count === 1 ? 'pair' : 'pairs'} · ${price}</span>`;
    button.setAttribute('aria-label', `Add ${box.name} to ${READY.where}: ${box.candles.join(', ')}`);
    button.addEventListener('click', async () => {
      button.setAttribute('aria-busy', 'true');
      for (const name of box.candles) {
        const card = [...grid.querySelectorAll(':scope > .bndlr-product')].find(c => titleFor(c) === normalise(name));
        card?.querySelector('.bndlr-add-to-bundle')?.click();
        await new Promise(resolve => setTimeout(resolve, 180));
      }
      button.removeAttribute('aria-busy');
    });
    row.append(button);
  });
  const intro = root.querySelector('.pyg-bundle-intro');
  if (intro) intro.after(section);
  else grid.before(section);
}

function buildTrayCard(info) {
  if (!GIFT || info.querySelector('.pyg-tray-card')) return;
  const wrap = document.createElement('div');
  wrap.className = 'pyg-tray-card';
  wrap.innerHTML = `
<button type="button" class="pyg-tray-card__toggle" aria-expanded="false" aria-controls="pyg-tray-card-body">Write their card +</button>
<div class="pyg-tray-card__body" id="pyg-tray-card-body" hidden>
<textarea maxlength="200" rows="3" placeholder="Light up someone’s day…" aria-label="Message for the complimentary gift card"></textarea>
<p class="pyg-tray-card__meta"><span class="pyg-tray-card__status" role="status"></span><span><span class="pyg-tray-card__count">0</span> / 200</span></p>
</div>`;
  const toggle = wrap.querySelector('.pyg-tray-card__toggle');
  const body = wrap.querySelector('.pyg-tray-card__body');
  const textarea = wrap.querySelector('textarea');
  const count = wrap.querySelector('.pyg-tray-card__count');
  const status = wrap.querySelector('.pyg-tray-card__status');
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const setLabel = () => {
    const open = !body.hidden;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.textContent = open ? 'Hide card' : (textarea.value.trim() ? 'Edit their card' : 'Write their card +');
  };
  /* The note may also have been written in the slide-out basket. Pull whatever the
     basket holds into this box, unless the shopper is typing here. */
  const pullSaved = () => fetch(root + 'cart.js', { credentials: 'same-origin' })
    .then(res => res.json())
    .then(cart => {
      const saved = cart?.attributes?.['Gift card message'];
      if (saved && saved !== textarea.value && document.activeElement !== textarea) {
        textarea.value = saved;
        count.textContent = saved.length;
        setLabel();
      }
    })
    .catch(() => {});
  toggle.addEventListener('click', () => {
    body.hidden = !body.hidden;
    setLabel();
    if (!body.hidden) { pullSaved(); textarea.focus(); }
  });
  let timer;
  textarea.addEventListener('input', () => {
    count.textContent = textarea.value.length;
    status.textContent = '';
    clearTimeout(timer);
    timer = setTimeout(async () => {
      await saveGiftCard(textarea.value);
      status.textContent = 'Saved';
    }, 600);
  });
  pullSaved();
  document.addEventListener('pyg:gift-card-saved', event => {
    const saved = event.detail && event.detail.message;
    if (typeof saved === 'string' && document.activeElement !== textarea) {
      textarea.value = saved;
      count.textContent = saved.length;
      setLabel();
    }
  });
  const cta = info.querySelector('.bndlr-status-box-add-to-cart');
  if (cta) info.insertBefore(wrap, cta);
  else info.append(wrap);
  if (cta && !cta.dataset.pygGift) {
    cta.dataset.pygGift = '1';
    /* Only save from here when there is something typed. An empty box must never
       wipe a note written in the slide-out basket. */
    cta.addEventListener('click', () => {
      if (textarea.value.trim()) saveGiftCard(textarea.value);
    }, true);
  }
}

/* ------------------------------------- */

/* Progress line: a nudge naming the next step, then a thick line. The solid
   part fills in thirds for 1, 2 and 3 pairs; after it, a fade leads to the
   4+ label (£24 a pair, free UK delivery), and fills in as 4, 5 and 6+ pairs
   are added. Desktop stops sit at 25%, 50%, 75% and the end; on phones at
   22%, 44%, 66% and the end, to leave room for the 4+ label. */
function buildTierBar() {
  const desktop = pairs => (pairs * 25) + '%';
  const phone = pairs => (pairs >= 4 ? 100 : pairs * 22) + '%';
  const bar = document.createElement('div');
  bar.className = 'pyg-tier-bar';
  bar.dataset.step = '0';
  bar.innerHTML = `
<p class="pyg-tier-nudge">${escapeHtml(NUDGES[0])}</p>
<div class="pyg-tier-track" role="progressbar" aria-label="Pairs chosen" aria-valuemin="0" aria-valuemax="4" aria-valuenow="0">
<span class="pyg-tier-line"></span><span class="pyg-tier-fill"></span>
<span class="pyg-tier-tail"><span class="pyg-tier-tail-fill"></span></span>
</div>
<ol class="pyg-tier-stops">${STOPS.map(stop =>
`<li data-pairs="${stop.pairs}"${stop.more ? ' class="is-more"' : ''} style="--at:${desktop(stop.pairs)};--at-m:${phone(stop.pairs)}">${stop.lines.map(line => '<span>' + escapeHtml(line) + '</span>').join('')}${stop.note ? '<span class="pyg-tier-note">' + escapeHtml(stop.note) + '</span>' : ''}</li>`).join('')}</ol>`;
  return bar;
}

function updateTierBar(root) {
  const bar = root.querySelector('.pyg-tier-bar');
  if (!bar) return;
  const pairs = pairsChosen(root);
  const step = Math.min(pairs, 6);
  if (bar.dataset.step === String(step) && bar.dataset.ready) return;
  bar.dataset.ready = '1';
  bar.dataset.step = String(step);
  bar.querySelector('.pyg-tier-nudge').textContent = NUDGES[Math.min(pairs, 4)];
  const track = bar.querySelector('.pyg-tier-track');
  track.setAttribute('aria-valuenow', String(Math.min(pairs, 4)));
  track.setAttribute('aria-valuetext', pairs + (pairs === 1 ? ' pair' : ' pairs') + ' chosen');
  bar.querySelectorAll('.pyg-tier-stops li').forEach(stop => {
    stop.classList.toggle('is-reached', pairs >= Number(stop.dataset.pairs));
  });
}

function buildIntro(root) {
  if (root.querySelector('.pyg-bundle-intro')) return;
  const title = root.querySelector('.bndlr-bundle-title');
  if (!title) return;
  title.textContent = COPY.title;
  root.querySelector('.bndlr-bundle-description')?.remove();
  const intro = document.createElement('section');
  intro.className = 'pyg-bundle-intro';
  intro.setAttribute('aria-labelledby', 'pyg-bundle-title');
  title.id = 'pyg-bundle-title';
  intro.append(title);
  if (GIFT) {
    const lede = document.createElement('p');
    lede.className = 'pyg-gift-lede';
    lede.textContent = GIFT_LEDE;
    intro.append(lede);
  }
  intro.append(buildTierBar());
  if (GIFT && GIFT_DEADLINE) {
    const deadline = document.createElement('p');
    deadline.className = 'pyg-gift-deadline';
    deadline.textContent = GIFT_DEADLINE;
    intro.append(deadline);
  }
  root.prepend(intro);
}

/* Filter: a narrow panel in the style of the Collections menu, with two
   lists (collection and colour). The chosen option is underlined. */
function filterOptions(options, withDots) {
  return options.map(([value, label]) => {
    const dot = withDots && value !== 'all'
      ? `<span class="pyg-filter-dot" aria-hidden="true" style="background:${SWATCHES[value] || '#D9D3C8'}"></span>`
      : '';
    return `<button type="button" class="pyg-filter-option" role="radio" data-value="${value}" aria-checked="${value === 'all'}">${dot}<span class="pyg-filter-text">${escapeHtml(label)}</span></button>`;
  }).join('');
}

function syncFilters(tools, grid) {
  tools.querySelectorAll('.pyg-filter-list').forEach(list => {
    const active = list.dataset.filter === 'collection' ? activeCollection : activeColour;
    list.querySelectorAll('.pyg-filter-option').forEach(option => {
      const on = String(option.dataset.value === active);
      if (option.getAttribute('aria-checked') !== on) option.setAttribute('aria-checked', on);
    });
  });
  const count = grid.querySelectorAll(':scope > .bndlr-product:not([hidden])').length;
  const text = count === 1 ? 'Showing 1 candle' : 'Showing ' + count + ' candles';
  const counter = tools.querySelector('.pyg-filter-count');
  if (counter && counter.textContent !== text) counter.textContent = text;
  const filtered = activeCollection !== 'all' || activeColour !== 'all';
  const clear = tools.querySelector('.pyg-filter-clear');
  if (clear && clear.hidden === filtered) clear.hidden = !filtered;
  const mark = tools.querySelector('.pyg-filter-mark');
  if (mark && mark.hidden === filtered) mark.hidden = !filtered;
}

function buildFilters(root, grid) {
  let tools = root.querySelector('.pyg-catalogue-tools');
  if (tools) return tools;
  tools = document.createElement('div');
  tools.className = 'pyg-catalogue-tools';
  tools.innerHTML = `
<details class="pyg-bundle-filter">
<summary class="pyg-filter-trigger">Filter <span class="pyg-filter-mark" aria-hidden="true" hidden></span><span class="pyg-disclosure-icon" aria-hidden="true"></span></summary>
<div class="pyg-filter-sheet">
<p class="pyg-filter-heading" id="pyg-filter-collection-label">Collection</p>
<div class="pyg-filter-list" role="radiogroup" aria-labelledby="pyg-filter-collection-label" data-filter="collection">${filterOptions(COLLECTION_LABELS, false)}</div>
<p class="pyg-filter-heading" id="pyg-filter-colour-label">Colour</p>
<div class="pyg-filter-list" role="radiogroup" aria-labelledby="pyg-filter-colour-label" data-filter="colour">${filterOptions(COLOUR_LABELS, true)}</div>
<div class="pyg-filter-foot"><span class="pyg-filter-count" role="status" aria-live="polite"></span><button type="button" class="pyg-filter-clear" hidden>Clear</button></div>
</div>
</details>`;
  const intro = root.querySelector('.pyg-bundle-intro');
  if (intro) intro.append(tools);
  else grid.before(tools);
  const choose = (kind, value) => {
    if (kind === 'collection') activeCollection = value;
    else activeColour = value;
    arrangeByColour(grid);
    applyFilters(grid);
    syncFilters(tools, grid);
  };
  tools.querySelectorAll('.pyg-filter-list').forEach(list => {
    list.addEventListener('click', event => {
      const option = event.target.closest('.pyg-filter-option');
      if (option) choose(list.dataset.filter, option.dataset.value);
    });
    list.addEventListener('keydown', event => {
      const forward = event.key === 'ArrowRight' || event.key === 'ArrowDown';
      const back = event.key === 'ArrowLeft' || event.key === 'ArrowUp';
      if (!forward && !back) return;
      const options = [...list.querySelectorAll('.pyg-filter-option')];
      let index = options.indexOf(document.activeElement);
      if (index < 0) return;
      event.preventDefault();
      index = (index + (forward ? 1 : -1) + options.length) % options.length;
      options[index].focus();
      choose(list.dataset.filter, options[index].dataset.value);
    });
  });
  tools.querySelector('.pyg-filter-clear').addEventListener('click', () => {
    activeCollection = 'all';
    activeColour = 'all';
    arrangeByColour(grid);
    applyFilters(grid);
    syncFilters(tools, grid);
  });
  tools.querySelectorAll('details').forEach(disclosure => {
    disclosure.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        disclosure.open = false;
        disclosure.querySelector('summary').focus();
      }
    });
  });
  document.addEventListener('click', event => {
    if (!tools.contains(event.target)) tools.querySelectorAll('details').forEach(details => { details.open = false; });
  });
  return tools;
}

/* Puts the candles in this season's colour order (COLOUR_ORDER above), with
   no headings. Only moves things when the order on the page is not already right. */
function arrangeByColour(grid) {
  grid.querySelectorAll(':scope > .pyg-group-heading').forEach(heading => heading.remove());
  const cards = [...grid.querySelectorAll(':scope > .bndlr-product')];
  if (!cards.length) return;
  const rank = new Map(COLOUR_ORDER.map((name, index) => [normalise(name), index]));
  /* With a colour chosen, that colour's own candles go first. */
  (COLOUR_BLOCKS[activeColour] || []).forEach((name, index) => rank.set(normalise(name), index - 1000));
  const place = card => rank.has(titleFor(card)) ? rank.get(titleFor(card)) : COLOUR_ORDER.length;
  const sorted = cards
    .map((card, index) => ({ card, index }))
    .sort((a, b) => (place(a.card) - place(b.card)) || (a.index - b.index))
    .map(entry => entry.card);
  if (sorted.every((card, index) => card === cards[index])) return;
  const end = grid.querySelector(':scope > .pyg-no-results');
  sorted.forEach(card => grid.insertBefore(card, end));
}

function matches(group, value, title) {
  return value === 'all' || (group[value] || []).includes(title);
}

function applyFilters(grid) {
  const cards = [...grid.querySelectorAll(':scope > .bndlr-product')];
  let visible = 0;
  cards.forEach(card => {
    const title = titleFor(card);
    const show = matches(COLLECTIONS, activeCollection, title) && matches(COLOURS, activeColour, title);
    if (card.hidden === show) card.hidden = !show;
    if (show) visible += 1;
  });
  let empty = grid.querySelector('.pyg-no-results');
  if (!visible && !empty) {
    empty = document.createElement('p');
    empty.className = 'pyg-no-results';
    empty.textContent = 'No candles match both filters. Try another combination.';
    grid.append(empty);
  }
  if (empty) empty.hidden = visible > 0;
}

function updateCardCopy(root) {
  root.querySelectorAll('.bndlr-add-to-bundle').forEach(button => {
    if (button.textContent.trim() !== COPY.add) button.textContent = COPY.add;
  });
}

function quantityFor(product) {
  const element = product.querySelector('.bndlr-product-quantity');
  return Math.max(1, parseInt(element?.getAttribute('product-quantity') || element?.textContent || '1', 10) || 1);
}

function selectedFor(root, key) {
  return [...root.querySelectorAll('.bndlr-mnm-selected-products > .bndlr-product')]
    .find(product => product.getAttribute('data-line-item-key') === key);
}

function availableFor(root, variant) {
  return [...root.querySelectorAll('.bndlr-mnm-available-products > .bndlr-product')]
    .find(card => [...card.querySelectorAll('select[name="variant_id"] option')]
      .some(option => option.value === variant));
}

function changeQuantity(root, key, change) {
  const selected = selectedFor(root, key);
  if (!selected) return;
  const variant = selected.getAttribute('data-variant-id');
  const available = availableFor(root, variant);
  const add = available?.querySelector('.bndlr-add-to-bundle');
  const remove = selected.querySelector('.bndlr-close');
  if (change < 0 && quantityFor(selected) === 1) {
    remove?.click();
    return;
  }
  if (!add || !remove) return;
  const select = available.querySelector('select[name="variant_id"]');
  const previousVariant = select?.value;
  if (select) select.value = variant;
  const quantity = change < 0 ? quantityFor(selected) - 1 : 1;
  const container = available.querySelector('.bndlr-add-to-bundle-container');
  if (!container) return;
  let input = container.querySelector('.quantity-input');
  const created = !input;
  if (created) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.className = 'quantity-input';
    container.append(input);
  }
  const previous = input.value;
  input.value = String(quantity);
  if (change < 0) remove.click();
  add.click();
  if (created) input.remove();
  else input.value = previous;
  if (select) select.value = previousVariant;
}

function showPhoto(source, title) {
  let dialog = document.querySelector('.pyg-photo-dialog');
  if (!dialog) {
    dialog = document.createElement('dialog');
    dialog.className = 'pyg-photo-dialog';
    dialog.setAttribute('aria-label', 'Candle detail');
    dialog.innerHTML = '<button type="button" class="pyg-photo-close" aria-label="Close candle detail">×</button><img alt=""><p></p>';
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    document.body.append(dialog);
  }
  dialog.querySelector('img').src = source;
  dialog.querySelector('img').alt = title;
  dialog.querySelector('p').textContent = title;
  dialog.showModal();
}

function updateStickyTray(root) {
  const tray = document.querySelector('#bndlr-mnm-status-box');
  const info = tray?.querySelector('.bdnlr-mnm-status-box-info-container');
  const productsContainer = tray?.querySelector('.bdnlr-mnm-status-box-products-container');
  if (!tray || !info || !productsContainer) return;
  const selectedProducts = [...root.querySelectorAll('.bndlr-mnm-selected-products > .bndlr-product')];
  const selectedKeys = new Set(selectedProducts.map(product => product.getAttribute('data-line-item-key')));
  for (const key of selectionOrder.keys()) if (!selectedKeys.has(key)) selectionOrder.delete(key);
  selectedKeys.forEach(key => { if (!selectionOrder.has(key)) selectionOrder.set(key, nextSelectionOrder++); });
  selectedProducts.sort((a, b) => selectionOrder.get(a.getAttribute('data-line-item-key')) - selectionOrder.get(b.getAttribute('data-line-item-key')));
  const selected = selectedProducts.reduce((total, product) => total + quantityFor(product), 0);
  tray.hidden = selected === 0;
  tray.dataset.pygCount = String(selectedProducts.length);
  const count = Math.max(1, selectedProducts.length);
  /* Same photo sizes on both builders: large when there are only a few candles, smaller as more are added. */
  const size = count <= 3 ? 205 : count === 4 ? 175 : count === 5 ? 145 : 125;
  tray.style.setProperty('--pyg-count', count);
  tray.style.setProperty('--pyg-photo-cap', size + 'px');

  const signature = selectedProducts.map(product =>
    product.getAttribute('data-line-item-key') + ':' + quantityFor(product)).join('|');
  if (productsContainer.dataset.pygSignature !== signature ||
      productsContainer.querySelectorAll('.pyg-tray-product').length !== selectedProducts.length) {
    const focusKey = document.activeElement?.closest('.pyg-tray-product')?.dataset.key;
    const focusAction = document.activeElement?.dataset.action;
    const trayProducts = selectedProducts.map((product, index) => {
      const key = product.getAttribute('data-line-item-key');
      const image = product.querySelector('.bndlr-product-image');
      const title = product.querySelector('.bndlr-product-title')?.textContent?.trim() || 'Candle ' + (index + 1);
      const quantity = quantityFor(product);
      const item = document.createElement('div');
      item.className = 'pyg-tray-product';
      item.dataset.key = key;
      if (image) {
        const zoom = document.createElement('button');
        zoom.type = 'button';
        zoom.className = 'pyg-tray-zoom';
        zoom.setAttribute('aria-label', 'Enlarge ' + title);
        const trayImage = image.cloneNode();
        trayImage.removeAttribute('srcset');
        trayImage.removeAttribute('sizes');
        trayImage.loading = 'eager';
        trayImage.className = 'pyg-tray-product-image';
        trayImage.alt = title;
        zoom.append(trayImage);
        zoom.addEventListener('click', () => showPhoto(image.src, title));
        item.append(zoom);
      }
      const name = document.createElement('span');
      name.className = 'pyg-tray-name';
      name.textContent = title + (quantity > 1 ? ' × ' + quantity : '');
      name.title = name.textContent;
      item.append(name);
      const controls = document.createElement('div');
      controls.className = 'pyg-tray-controls';
      for (const [action, symbol, label] of [['less', '−', 'Remove one pair of '], ['more', '+', 'Add one pair of ']]) {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.action = action;
        button.textContent = symbol;
        button.setAttribute('aria-label', label + title);
        button.addEventListener('click', () => changeQuantity(root, key, action === 'more' ? 1 : -1));
        controls.append(button);
      }
      item.append(controls);
      return item;
    });
    productsContainer.replaceChildren(...trayProducts);
    productsContainer.dataset.pygSignature = signature;
    if (focusKey && focusAction) {
      const replacement = [...productsContainer.children].find(item => item.dataset.key === focusKey);
      (replacement?.querySelector('[data-action="' + focusAction + '"]') ||
        productsContainer.querySelector('button') ||
        root.querySelector('.bndlr-add-to-bundle'))?.focus({ preventScroll: true });
    }
  }

  let label = info.querySelector('.pyg-table-label');
  if (!label) {
    label = document.createElement('span');
    label.className = 'pyg-table-label';
    label.textContent = COPY.trayLabel;
    info.prepend(label);
  }
  let summary = info.querySelector('.pyg-sticky-summary');
  if (!summary) {
    summary = document.createElement('div');
    summary.className = 'pyg-sticky-summary';
    summary.setAttribute('role', 'status');
    summary.setAttribute('aria-live', 'polite');
    summary.setAttribute('aria-atomic', 'true');
    info.insertBefore(summary, info.querySelector('.bndlr-status-box-add-to-cart'));
  }
  /* Short next-step nudge, sitting just before the pairs and total. */
  let trayNudge = info.querySelector('.pyg-tray-nudge');
  if (!trayNudge) {
    trayNudge = document.createElement('span');
    trayNudge.className = 'pyg-tray-nudge';
    info.insertBefore(trayNudge, summary);
  }
  const nudgeText = TRAY_NUDGES[Math.min(selected, 4)] || '';
  if (trayNudge.textContent !== nudgeText) trayNudge.textContent = nudgeText;
  trayNudge.hidden = !nudgeText;
  const totalElement = root.querySelector('.bndlr-mnm-total-price');
  const currentPrice = totalElement?.querySelector('.bndlr-new-price');
  const total = (currentPrice || totalElement)?.textContent?.replace(/Original price|Discounted price|Total:/g, '').trim() || '';
  const detailText = selected + (selected === 1 ? ' pair' : ' pairs') + (total ? ' · ' + total : '');
  if (summary.textContent !== detailText) summary.textContent = detailText;
  const cta = info.querySelector('.bndlr-status-box-add-to-cart');
  buildTrayCard(info);
  let requirement = info.querySelector('.pyg-tray-requirement');
  if (!requirement) {
    requirement = document.createElement('span');
    requirement.className = 'pyg-tray-requirement';
    info.append(requirement);
  }
  const nativeRequirement = info.querySelector('.bndlr-mnm-instructions-text')?.textContent?.trim() || '';
  const missing = nativeRequirement.match(/needs (\d+) more/);
  const requirementText = missing ? 'Choose ' + missing[1] + ' more ' + (missing[1] === '1' ? 'pair' : 'pairs') : nativeRequirement;
  if (requirement.textContent !== requirementText) requirement.textContent = requirementText;
  requirement.hidden = !cta?.classList.contains('bndlr-hidden') || !requirementText;
  if (cta && !cta.classList.contains('bndlr-loading') && cta.textContent.trim() !== COPY.cta) {
    cta.textContent = COPY.cta;
    cta.title = COPY.cta;
  }
  if (!tray.pygResizeObserver) {
    tray.pygResizeObserver = new ResizeObserver(() => {
      document.documentElement.style.setProperty('--pyg-tray-height', tray.hidden ? '0px' : Math.ceil(tray.getBoundingClientRect().height) + 'px');
    });
    tray.pygResizeObserver.observe(tray);
  }
}

function suppressBundlePopups() {
  document.body?.classList.remove('klaviyo-prevent-body-scrolling');
  document.querySelectorAll('[class*="kl-private-reset"], .klaviyo-form, [data-testid^="klaviyo-form"]')
    .forEach(element => {
      let node = element;
      let fixedAncestor = null;
      while (node && node !== document.body) {
        if (window.getComputedStyle(node).position === 'fixed') fixedAncestor = node;
        node = node.parentElement;
      }
      const target = fixedAncestor || element.closest('[role="dialog"]') || element.closest('.klaviyo-form');
      if (!target) return;
      target.hidden = true;
      target.setAttribute('aria-hidden', 'true');
      target.style.setProperty('display', 'none', 'important');
    });
}

function initialise() {
  const root = document.querySelector('.bndlr-landing-page');
  const grid = root?.querySelector('.bndlr-mnm-available-products');
  if (!root || !grid) return;
  document.documentElement.classList.add('pyg-bundle-page');
  if (GIFT) document.documentElement.classList.add('pyg-gift-page');
  injectStyles();
  buildIntro(root);
  const tools = buildFilters(root, grid);
  buildGiftBoxes(root, grid);
  updateCardCopy(root);
  arrangeByColour(grid);
  applyFilters(grid);
  syncFilters(tools, grid);
  updateTierBar(root);
  updateStickyTray(root);
  suppressBundlePopups();
}

function queueRefresh() {
  if (refreshQueued) return;
  refreshQueued = true;
  window.requestAnimationFrame(() => {
    refreshQueued = false;
    initialise();
  });
}

['DOMContentLoaded', 'bundler:bundle_widget_created', 'bundler:mixnmatch_refreshed', 'bundler:loaded']
  .forEach(eventName => document.addEventListener(eventName, queueRefresh));

new MutationObserver(queueRefresh).observe(document.documentElement, { childList: true, subtree: true });
queueRefresh();
})();
